import { Component, OnInit } from '@angular/core';
import { UserHeaderComponent } from '../../core/component/user-header/user-header.component';
import { UserFooterComponent } from '../../core/component/user-footer/user-footer.component';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.scss'],
  standalone: true,
  imports: [RouterOutlet, UserHeaderComponent, UserFooterComponent]
})
export class DefaultComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
